export default __webpack_public_path__ + "static/media/lowpop.f6916f2a.wav";